import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import FamilyForm from "@/components/FamilyForm";
import { pub, setToken, getToken, errMsg, useOverview } from "@/lib/api";

export default function Register() {
  const { data, isLoading } = useOverview();
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const qc = useQueryClient();

  const submit = async (payload) => {
    setBusy(true);
    try {
      const { data: res } = await pub.post("/families", payload);
      setToken("family", res.token);
      qc.invalidateQueries({ queryKey: ["overview"] });
      toast.success("Faʻafetai! Your family is registered.");
      nav("/my-family");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
      <p className="label-cap">Join the reunion</p>
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-amber-950 mt-2">Register your family</h1>
      <p className="text-lg text-stone-700 mt-4 mb-8">Fill this out once for your whole household. You can change it any time from <Link to="/my-family" className="underline font-semibold">My Family</Link>.</p>
      {getToken("family") && (
        <div data-testid="already-registered-notice" className="card-warm !bg-green-50 !border-green-300 mb-8 text-lg">
          You already registered on this device. <Link to="/my-family" className="underline font-bold">Open My Family</Link> to make changes.
        </div>
      )}
      {data?.settings?.registration_open === false ? (
        <div data-testid="registration-closed" className="card-warm text-lg">Registration is closed right now. Please contact an organizer.</div>
      ) : isLoading ? <p className="text-lg">Loading…</p> : (
        <FamilyForm data={data} onSubmit={submit} busy={busy} submitLabel="Register my family" />
      )}
    </div>
  );
}
